import { render, staticRenderFns } from "./editserviceprovider.vue?vue&type=template&id=c840c54c"
import script from "./editserviceprovider.vue?vue&type=script&lang=js"
export * from "./editserviceprovider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports